
import * as models from "@/code/models";
import * as validate from "@/code/validation";
import { Component, Vue } from "vue-property-decorator";
import Nav from "@/components/Nav.vue";
import Footerr from "@/components/Footerr.vue";
import VueTelInputVuetify from "vue-tel-input-vuetify/lib/vue-tel-input-vuetify.vue";

export default Vue.extend({
  name: "home",
  components: {
    Footerr,
    Nav,
    VueTelInputVuetify,
  },
  data: () => ({
    dialog: false,
    dialog2: false,
    dialog3: false,
    dialoges: {
      success: false,
    },
    error: {
      displayError: false,
    },
    validationRules: validate.validation,
    newData: {} as models.ticket,
    editData: {} as models.ticket,
    allTickets: [] as models.ticket[],
    lists: [
      { title: "Edit", iconn: "mdi-grease-pencil" },
      { title: "Delete", iconn: "mdi-delete-forever-outline" },
    ],
  }),
  watch: {
    "$store.state.Tickets": {
      immediate: true,
      deep: true,
      handler() {
        this.allTickets = this.$store.state.Tickets;
      },
    },
  },
  methods: {
    AddTicket() {
      const form = this.$refs.addTickect as HTMLFormElement;
      if (form && form.validate()) {
        console.log("heloo");
        this.newData.id = Math.random();
        this.newData.ticketStatus = 3;
        this.$store.state.Tickets.push(this.newData);
        console.log(this.$store.state.Tickets);
        this.dialoges.success = true;
        this.dialog3 = false;
      } else {
        this.error.displayError = true;
      }
    },
    sendID(ticket: models.ticket) {
      this.editData = Object.assign({}, ticket);
      console.log(this.editData);
    },
    EditTicket() {
      const form = this.$refs.changeData as HTMLFormElement[];
      console.log(form);
      if (form && form[0].validate()) {
        let ticketss = this.$store.state.Tickets;
        // let getTicket = ticketss.filter((x: models.ticket) => x.id == this.editData.id);
        // getTicket[0] = this.editData;
        for (let i = 0; i < ticketss.length; i++) {
          if (ticketss[i].id == this.editData.id) {
            ticketss[i] = this.editData;
          }
        }
        this.$store.commit("get_ticket", ticketss);
        this.dialoges.success = true;
        this.dialog = false;
        console.log(this.editData);
      } else {
        this.error.displayError = true;
      }
    },
    DeleteTicket(id: number) {
      // get all tickets that doesn't have the id of the ticket I want to delete
      let ticketss = this.$store.state.Tickets.filter(
        (x: models.ticket) => x.id != id
      );
      this.$store.commit("get_ticket", ticketss);
    },
  },
});
